import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-a35594d4"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "aggregate-daily-sales-report"
};
var _hoisted_2 = {
  class: "container"
};
var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "title"
  }, "充值消费统计", -1);
});
var _hoisted_4 = {
  class: "box"
};
var _hoisted_5 = {
  class: "tab"
};
var _hoisted_6 = ["onClick"];
var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "title"
  }, "数据总览", -1);
});
var _hoisted_8 = {
  class: "num"
};
var _hoisted_9 = {
  class: "desc"
};
var _hoisted_10 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "title mt-2 flex align-center justify-between"
  }, " 充值消费记录 ", -1);
});
var _hoisted_11 = {
  class: "rankList"
};
var _hoisted_12 = {
  class: "tab"
};
var _hoisted_13 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_c_type_tab = _resolveComponent("c-type-tab");
  var _component_c_date_header_with_btn = _resolveComponent("c-date-header-with-btn");
  var _component_pie_echart = _resolveComponent("pie-echart");
  var _component_van_grid_item = _resolveComponent("van-grid-item");
  var _component_van_grid = _resolveComponent("van-grid");
  var _component_rank_list_item = _resolveComponent("rank-list-item");
  var _component_van_list = _resolveComponent("van-list");
  var _component_c_no_data = _resolveComponent("c-no-data");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_c_type_tab, {
    onConfirmType: _ctx.confirmType,
    typeTabs: _ctx.typeTabs
  }, null, 8, ["onConfirmType", "typeTabs"]), _createVNode(_component_c_date_header_with_btn, {
    ref: "dateRef",
    type: _ctx.params.type,
    onConfirmDate: _ctx.confrimDate,
    showBtn: false
  }, null, 8, ["type", "onConfirmDate"]), _hoisted_3, _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countTabs, function (item) {
    return _openBlock(), _createElementBlock("div", {
      key: item,
      class: _normalizeClass([{
        tabActive: item === _ctx.countCurTab,
        tabActiveLeft: item === '充值(元)' && item === _ctx.countCurTab,
        tabActiveRight: item === '消费(元)' && item === _ctx.countCurTab
      }, "tabItem"]),
      onClick: function onClick($event) {
        return _ctx.countTabClick(item);
      }
    }, _toDisplayString(item), 11, _hoisted_6);
  }), 128))]), _createVNode(_component_pie_echart, _normalizeProps(_guardReactiveProps(_ctx.countInfoPie)), null, 16)]), _hoisted_7, _createVNode(_component_van_grid, {
    class: "grid",
    gutter: 10,
    "column-num": 3
  }, {
    default: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countData, function (item) {
        return _openBlock(), _createBlock(_component_van_grid_item, {
          key: item.material_name
        }, {
          default: _withCtx(function () {
            return [_createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.emptyStringFormat(item.num)), 1), _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.emptyStringFormat(item.desc)), 1)];
          }),
          _: 2
        }, 1024);
      }), 128))];
    }),
    _: 1
  }), _hoisted_10, _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, function (item) {
    return _openBlock(), _createElementBlock("div", {
      key: item,
      class: _normalizeClass([{
        tabActive: item === _ctx.curTab,
        tabActiveLeft: item === '充值(元)' && item === _ctx.curTab,
        tabActiveRight: item === '消费(元)' && item === _ctx.curTab
      }, "tabItem"]),
      onClick: function onClick($event) {
        return _ctx.tabClick(item);
      }
    }, _toDisplayString(item), 11, _hoisted_13);
  }), 128))]), _ctx.logInfo.length ? (_openBlock(), _createBlock(_component_van_list, {
    key: 0,
    loading: _ctx.listLoading,
    "onUpdate:loading": _cache[0] || (_cache[0] = function ($event) {
      return _ctx.listLoading = $event;
    }),
    finished: _ctx.listFinished,
    "finished-text": "没有更多了",
    onLoad: _ctx.getLogInfo
  }, {
    default: _withCtx(function () {
      return [_ctx.logInfo.length && _ctx.rechargeTypeInfo.money ? (_openBlock(true), _createElementBlock(_Fragment, {
        key: 0
      }, _renderList(_ctx.logInfo, function (item, index) {
        return _openBlock(), _createBlock(_component_rank_list_item, {
          key: index,
          type: "aggregate",
          item: item,
          index: index,
          typeList: _ctx.rechargeTypeInfo.money
        }, null, 8, ["item", "index", "typeList"]);
      }), 128)) : _createCommentVNode("", true)];
    }),
    _: 1
  }, 8, ["loading", "finished", "onLoad"])) : (_openBlock(), _createBlock(_component_c_no_data, {
    key: 1
  }))])])]);
}